
import {
  defineComponent, ref, PropType,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { useStoryblok } from '~/composables/useStoryblok';
import { IAccessoryProperties } from '~/types/fightcamp';
import PackageIncludeModalTemplate from './PackageIncludeModalTemplate.vue';

export default defineComponent({
  name: 'AllIncludedModal',
  components: {
    FCImage,
    PackageIncludeModalTemplate,
  },
  props: {
    includeProducts: {
      type: Array as PropType<IAccessoryProperties[]>,
      required: false,
      default: () => {},
    },
    packageName: {
      type: String,
      required: true,
    },
    isViewAll: {
      type: Boolean,
      default: true,
    },
    activeProduct: {
      type: Object as PropType<IAccessoryProperties>,
      default: null,
    },
  },
  setup(props, context) {
    const closeModal = () => {
      context.emit('close');
    };

    const title = ref(props.packageName);
    const modalViewAll = ref(props.isViewAll);
    const displayProduct = ref(props.activeProduct);
    function showProductDetails(product: IAccessoryProperties) {
      modalViewAll.value = false;
      displayProduct.value = product;
      title.value = product.productName;
    }

    const { renderRichText } = useStoryblok();

    function getImageProperties(product: IAccessoryProperties) {
      return {
        src: product?.lifestyleImage?.src || product?.primaryImg?.src,
        alt: product?.lifestyleImage?.alt || product?.primaryImg?.alt,
      };
    }

    return {
      closeModal,
      modalViewAll,
      showProductDetails,
      displayProduct,
      title,
      displayRichText: (body: any) => renderRichText(body),
      getImageProperties,
    };
  },
});
